import template from './cycle_stage_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class CycleStageHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.step_sequence = ko.observable(1);
	};

	close()
	{
		this.dialog.close();
	}

	move_order_up()
	{
		this.step_sequence(this.step_sequence() + 1);
	}

	move_order_down()
	{
		this.step_sequence(this.step_sequence() - 1);
	}
};

class CycleStageHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new CycleStageHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'CycleStageHelp',
	dialog_class: CycleStageHelpPage,
	template: template,
	template_filename: 'translation/dialogs/cycle_stage_help',
	provider: 'ps'
};